import { FC, SVGProps } from "react";

const SearchIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M88.1075 83.1075L62.1225 57.1225C73.3625 43.3775 72.5725 23.0775 59.7475 10.2525C46.0775 -3.4175 23.9175 -3.4175 10.2525 10.2525C-3.4175 23.9225 -3.4175 46.0825 10.2525 59.7525C23.0775 72.5775 43.3775 73.3675 57.1225 62.1275L83.1075 88.1125C84.4875 89.4925 86.7275 89.4925 88.1075 88.1125C89.4875 86.7275 89.4875 84.4875 88.1075 83.1075ZM13.7875 56.2125C2.0725 44.4975 2.0725 25.5025 13.7875 13.7875C25.5025 2.0725 44.4975 2.0725 56.2125 13.7875C67.9275 25.5025 67.9275 44.4975 56.2125 56.2125C44.4975 67.9325 25.5025 67.9325 13.7875 56.2125Z"
        fill="white"
      />
    </svg>
  );
};

export default SearchIcon;
